// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"234":"1afffbea","329":"24b4c954","714":"01fc6ccc"}[chunkId] + ".chunk.css";
};